import React from 'react'
import {
  createStyles,
  makeStyles,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core'
import Price from '../Shop/Price'
import { truncateString } from '../../utils/utils'
import TaxonPromotionBadge from '../Shop/TaxonPromotionBadge'
import clsx from 'clsx'

const useStyles = makeStyles((theme) =>
  createStyles({
    productCard: {
      minHeight: 70,
      font: '12px',
      display: 'flex',
      alignItems: 'center',
      marginBottom: theme.spacing(2),
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(1),
      },
    },
    checkBox: {},
    imgContainer: {
      display: 'flex',
      alignItems: 'center',
      width: 85,
      height: 85,
      position: 'relative',
      marginRight: theme.spacing(1),
      [theme.breakpoints.up('md')]: {
        marginRight: theme.spacing(2),
        width: 50,
        height: 50,
      },
    },
    imgProduct: {
      width: '100%',
      objectFit: 'contain',
      marginLeft: theme.spacing(0),
      [theme.breakpoints.up('md')]: {},
    },
    productInformation: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-around',
      width: '100%',
      [theme.breakpoints.up('md')]: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
      },
    },
    productName: {
      display: 'flex',
      alignItems: 'baseline',
      [theme.breakpoints.up('md')]: {},
    },
    productNameString: {
      [theme.breakpoints.down('md')]: {
        fontSize: 11,
      },
    },
    productQuantity: {
      width: '10%',
    },
    smallerText: {
      fontSize: 13,
      [theme.breakpoints.down('md')]: {
        fontSize: 10,
      },
      whiteSpace: 'nowrap',
    },
    productPrice: {
      display: 'flex',
      alignItems: 'flex-end',
    },
    productContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      width: '100%',
    },
  })
)

type Tprops = {
  settings: any
  productName: string
  productImage: string
  productPrice: number
  productState: string
  quantity?: number
  taxonPromotionPercent?: number
}

const OrderSecondHandProductRow = ({
  productName,
  productImage,
  productPrice,
  productState,
  quantity = 1,
  settings,
  taxonPromotionPercent,
}: Tprops) => {
  const classes = useStyles()
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <div className={classes.productCard}>
      <div>
        <div className={classes.imgContainer}>
          <img
            src={productImage ?? settings?.default_image?.url}
            alt={productName}
            className={classes.imgProduct}
          />
        </div>
      </div>
      <div className={classes.productContainer}>
        <TaxonPromotionBadge percent={taxonPromotionPercent} />
        <div className={classes.productInformation}>
          <div
            className={clsx(classes.productName, 'recapOrder__product-name')}
          >
            <Typography variant={'body2'}>x{quantity}</Typography>
            &nbsp;
            {isSmallScreen ? (
              <Typography variant={'h5'} className={classes.productNameString}>
                {truncateString(productName, 24)}
              </Typography>
            ) : (
              <Typography variant={'h5'}>{productName}</Typography>
            )}
          </div>

          <Typography
            variant={'h5'}
            className={clsx(
              classes.productNameString,
              'recapOrder__product-state'
            )}
          >
            {productState}
          </Typography>

          <Typography
            variant={'body2'}
            className={clsx(classes.smallerText, 'recapOrder__product-price')}
          >
            <Price amount={productPrice} showDayOrMonth={false} />
          </Typography>
        </div>
      </div>
    </div>
  )
}

export default OrderSecondHandProductRow
